<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal modal--welcomeback modal--unsubscribe', isIos ? 'ui_desc_ios' : '']" id="unsubscribe_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_choice_in_level }}</h1>
          <img :src="getTranslations.project_config_modal_img" alt="">
          <p> {{ getTranslations.home_modals_unsubscribe_choice_if_you }} </p>
          <p>{{ getTranslations.home_modals_unsubscribe_choice_do_you_want }}</p>
        </div>
        <div class="modal__footer">
          <a class="ti_btn--main" @click="unsubscribe" style="cursor:pointer">
              {{ getTranslations.home_modals_unsubscribe_choice_unsubscribe }}
          </a>
          <br><br>
          <a class="ti_btn--second" @click="noUnSubscribe" style="cursor:pointer">
              {{ getTranslations.home_modals_unsubscribe_choice_cancel }}
          </a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import modals from '../../../common/modals';
import Resubscribe from './Resubscribe';
import ResubscribeQuestionViaSms from './ResubscribeQuestionViaSms';

export default {
  // modal_unsubscribe.html
  name: 'unsubscribe',
  data() {
    return {
      isIos: false,
    };
  },
  components: {
    Resubscribe,
    ResubscribeQuestionViaSms,
  },
  created() {
    console.log('in Unsub created hook');
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapActions('common', [
      'optoutCall',
    ]),
    noUnSubscribe() {
      modals.hideModal(this);
    },
    unsubscribe() {
      this.optoutCall().then(() => {
        this.getUserLoginDetails().then(() => {
          if (this.userDetails.subscribed) {
            modals.hideModal(this);
          } else {
            if (this.subAndUnsubViaSMS && (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS')) {
              this.storeModalForSettings(ResubscribeQuestionViaSms);
            } else {
              this.storeModalForSettings(Resubscribe);
            }
            modals.showHideModal(this);
          }
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>

<style type="text/css">
  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/Unsubscribe.vue